import { IMessageBarStyles, MessageBar, MessageBarType } from "@fluentui/react";
import React from "react";

import { FailureSeverity, ValidationFailure } from "../../utils/validation/ValidationResult";

interface FormFailureMessagesProps {
    styles?: IMessageBarStyles;
    failures: ValidationFailure[];
    severity: FailureSeverity;
    testId?: string;
    isVertical?: boolean;
    renderCustomMessage?(groupedFailures: Map<string, string[]>, item: string): JSX.Element | undefined;
}

export const FormFailureMessages: React.FC<FormFailureMessagesProps> = ({
    styles,
    failures,
    severity,
    testId,
    isVertical,
    renderCustomMessage
}: FormFailureMessagesProps) => {
    const groupedFailures = failures
        .filter((item) => item.severity === severity)
        .reduce(
            (acc, error) => acc.set(error.code, [...(acc.get(error.code) ?? []), error.message]),
            new Map<string, string[]>()
        );

    const messageBarType = getMessageBarType(severity);

    return (
        <>
            {Array.from(groupedFailures.keys()).map((item) => (
                <div key={item}>
                    <MessageBar
                        styles={styles}
                        key={item}
                        messageBarType={messageBarType}
                        isMultiline={true}
                        data-testid={testId}
                    >
                        {renderCustomMessage
                            ? renderCustomMessage(groupedFailures, item) || groupedFailures.get(item)
                            : groupedFailures.get(item)}
                    </MessageBar>
                    {isVertical && <br />}
                </div>
            ))}
        </>
    );
};

const getMessageBarType = (severity: FailureSeverity): MessageBarType | undefined => {
    switch (severity) {
        case FailureSeverity.Error: {
            return MessageBarType.error;
        }

        case FailureSeverity.Warning: {
            return MessageBarType.warning;
        }

        default: {
            return undefined;
        }
    }
};
